<template>
  <div class="card">
    <div class="card-header"><i class="icon-refresh"></i> Filtrer</div>

    <div class="card-block">
      <div class="row">
        <div class="col-sm-6 form-group">
          <label>Créé après le</label>
          <datepicker
            v-model="filters.createdAtBegin"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>

        <div class="col-sm-6 form-group">
          <label>Créé avant le</label>
          <datepicker
            v-model="filters.createdAtEnd"
            format="dd.MM.yyyy"
            language="fr"
            input-class="form-control"
          ></datepicker>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 form-group">
          <label>Entreprise</label>
          <v-select
            v-model="filters.companyId"
            :options="companiesOptions"
            @search="searchCompanies"
          ></v-select>
        </div>
        <div class="col-sm-6 form-group">
          <label>Nom</label>
          <input
            class="form-control"
            v-model="filters.label"
            placeholder="Nom du lot"
          />
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button
        type="button"
        class="btn btn-sm btn-secondary"
        @click="applyFilters"
      >
        <i class="icon-eye"></i>&nbsp; Visualiser
      </button>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";

import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Datepicker,
  },

  data() {
    return {
      filters: {
        createdAtBegin: null,
        createdAtEnd: null,
        label: "",
        companyId: null,
      },
      companiesOptions: [],
    };
  },

  methods: {
    applyFilters() {
      this.$emit("apply", {
        ...this.filters,
        companyId: this.filters.companyId?.value,
      });
    },

    searchCompanies(search, loading) {
      if (search !== "") {
        this.fetchCompanies(search, loading, this);
      }
    },

    fetchCompanies: debounce(async (search, loading, vm) => {
      if (!search || search.length < 3) {
        return;
      }

      loading(true);

      const { data } = await vm.$api.post("/companies/search", {
        query: search,
      });

      vm.companiesOptions = data.map((c) => ({
        label: c.name,
        value: c.id,
      }));

      loading(false);

      return vm.clients;
    }, 300),
  },
};
</script>
